module.exports = "<ul id=\"stack_slamet\" class=\"stack stack--slamet\">\n  <ng-content></ng-content>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// /home/travis/build/RaphaelYan/ngx-deck/src/stack/stack.component.html
// module id = ../../../../../src/stack/stack.component.html
// module chunks = main